import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import DropdownInput from '../../../core/DropdownInput';

export const StyledWrapInputs = styled.div`
  margin-bottom: ${rem('10px')};
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    order: 2;
  `};
`;

export const StyledBoxInputRow = styled.div`
  margin-bottom: ${rem('10px')};
  order: 1;
  padding-bottom: ${rem('9px')};
  position: relative;
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 ${rem('10px')} ${rem('36px')};
    padding-bottom: 0;
    width: 100%;
  `};
`;

export const StyledBoxInputRowTwo = StyledBoxInputRow.extend`
  ${mediaqueries.greaterThan('tablet')`
    align-items: center;
    display: flex;
    padding: 0 0 ${rem('9px')} 0;
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 0 ${rem('36px')};
    padding-bottom: 0;
  `};
`;

export const StyleWrapIcon = styled.div`
  flex-basis: ${rem('25px')};
  margin: ${rem('9px')} 0 0 auto;
  order: 3;
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('6px')} 0 ${rem('5px')} ${rem('30px')};
  `};
`;

export const StyledDropdownInputMonths = styled(DropdownInput)`
  display: inline-block;
  margin: 0 ${rem('10px')} 0 ${rem('12px')};
  width: ${rem('125px')};
`;

export const StyledDropdownInputYears = styled(DropdownInput)`
  display: inline-block;
  margin: 0 ${rem('10px')};
  width: ${rem('75px')};
`;

export const StyledBoxInputRowTwoBis = StyledBoxInputRowTwo.extend`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${mediaqueries.greaterThan('tablet')`
    flex-direction: row;
  `};
`;

export const StyledBoxTwoComponents = styled.div`
  width: 100%;
  &:nth-child(1) {
    margin-bottom: 19px;
  }
  ${mediaqueries.greaterThan('tablet')`
    flex-direction: row;
    width: 46%;
    &:nth-child(1) {
    margin-bottom: 0px;
  }
  `};
`;
